import GalleryManager from "@/components/shared/GalleryManager";

const AdminGallery = () => {
  return (
    <div className="container mx-auto py-2">
      <GalleryManager role="admin" />
    </div>
  );
};

export default AdminGallery;
